import { api } from 'common';

export interface PharmacyWithDistance extends api.Pharmacy.PrevisitPharmacy {
  distance?: number;
}

export function isPrevisitPharmacy(
  pharmacy: any,
): pharmacy is api.Pharmacy.PrevisitPharmacy {
  if (!pharmacy) return false;
  return pharmacy.id !== undefined && pharmacy.name !== undefined;
}
